require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/babel-loader/lib/index.js?{\"presets\":[[\"/home/circleci/repo/node_modules/babel-preset-env/lib/index.js\",{\"targets\":{\"browsers\":[\"last 2 Chrome versions\"],\"uglify\":true}}],[\"/home/circleci/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/home/circleci/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/home/circleci/repo/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/home/circleci/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/home/circleci/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/circleci/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"transform-regenerator\"],\"cacheDirectory\":true}!./full-width.js") })
        }
      }, "component---src-templates-full-width-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=component---src-templates-full-width-js!./src/templates/full-width.js
// module id = 319
// module chunks = 231608221292675